import { useNavigate } from "react-router-dom";
import { useState } from "react";

const MeetingEnd = () => {
  const rating = ["Poor", "Fair", "Average", "Great", "Excellent"];
  const navigate = useNavigate();
  const [selectedRating, setSelectedRating] = useState(null);
  const [notes, setNotes] = useState("");

  const handleRatingClick = (item, index) => {
    setSelectedRating(index);
    console.log(`Rating: ${item}`);
  };

  const handleSubmit = () => {
    // Handle form submission here if needed
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#F8F8F8] p-4 md:p-8">
      <div className="flex flex-col lg:flex-row items-center justify-center min-h-screen max-w-7xl mx-auto gap-8 lg:gap-16">

        {/* Rating Section */}
        <div className="flex flex-col items-center w-full lg:w-1/2 text-center">
          <img
            src="/ApnaSanatan.svg"
            alt="Apna Sanatan Logo"
            className="h-12 md:h-16 mb-6"
          />

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#F05A22] mb-6 md:mb-8 max-w-2xl leading-tight">
            Tell us how was your Consultation Experience
          </h2>

          {/* Rating Stars - Responsive Grid */}
          <div className="grid grid-cols-5 gap-2 sm:gap-4 md:gap-6 lg:gap-8 w-full max-w-2xl px-4">
            {rating.map((item, index) => (
              <div key={index} className="flex flex-col items-center">
                <img
                  src="/star.svg"
                  alt="Star"
                  className={`w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 cursor-pointer transition-all duration-200 hover:scale-110 ${selectedRating === index
                      ? 'scale-110 filter brightness-110'
                      : selectedRating !== null && selectedRating !== index
                        ? 'opacity-50'
                        : ''
                    }`}
                  onClick={() => handleRatingClick(item, index)}
                />
                <p className="text-[#F05A22] text-xs sm:text-sm md:text-lg lg:text-xl font-semibold mt-1 md:mt-2 text-center">
                  {item}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Notes Section */}
        <div className="flex flex-col w-full lg:w-1/2 max-w-2xl">
          <h2 className="font-semibold text-gray-600 text-lg md:text-xl mb-3 text-center lg:text-left">
            Add Notes about your Consultation
          </h2>

          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className="bg-[#F7F7F7] rounded-lg w-full h-32 sm:h-40 md:h-48 lg:h-52 resize-none p-3 md:p-4 outline-none focus:outline-none focus:ring-2 focus:ring-[#F05A22] focus:ring-opacity-20 transition-all duration-200"
            placeholder="Write your notes here..."
          />

          <button
            onClick={handleSubmit}
            className="mt-4 md:mt-6 w-full py-3 md:py-4 px-5 bg-[#F05A22] text-white font-bold rounded-xl hover:bg-[#E04A1C] active:scale-95 transition-all duration-200 ease-in-out shadow-md hover:shadow-lg"
          >
            Return to Dashboard
          </button>
        </div>
      </div>

      {/* Mobile Bottom Spacing */}
      <div className="h-8 lg:hidden"></div>
    </div>
  );
};

export default MeetingEnd;